import { tokens } from "../../../../theme";
import { Box, TextField, Typography, useTheme } from "@mui/material";
import { refreshDrawerStyles } from "./styles";

const UNCHANGED = ["Services", "Seed data", "Tf & DP libs", "baseConfigBranch"];

const UiPanel = ({ uiTag, setUiTag }) => {
  const theme = useTheme();
  const { refreshDrawer } = refreshDrawerStyles(tokens(theme.paletteId));
  return (
    <>
      <Box sx={refreshDrawer.card}>
        <Box sx={{ ...refreshDrawer.cardBody, pt: "14px" }}>
          <Box>
            <Typography sx={refreshDrawer.cardTitle}>
              Refresh only the UI
            </Typography>
            <Typography sx={refreshDrawer.cardDescription}>
              Backend services, seed data and Terraform stay untouched. Only the
              web bundle is replaced.
            </Typography>
          </Box>
          <Box sx={refreshDrawer.fieldRow}>
            <Typography sx={refreshDrawer.fieldLabel}>Custom tag</Typography>
            <TextField
              size="small"
              placeholder="TS-????"
              value={uiTag}
              onChange={(e) => setUiTag(e.target.value)}
              sx={refreshDrawer.monoInput}
              inputProps={{ "aria-label": "Custom tag" }}
            />
            <Typography sx={refreshDrawer.fieldHelper}>
              Leave empty to use the environment's current UI tag.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={refreshDrawer.card}>
        <Box sx={refreshDrawer.cardBody}>
          <Typography sx={refreshDrawer.eyebrow}>
            Unchanged by this run
          </Typography>
          <Box sx={refreshDrawer.pillRow}>
            {UNCHANGED.map((item) => (
              <Box key={item} sx={refreshDrawer.neutralPill}>
                {item}
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default UiPanel;
